import { useMemo } from "react";
import { useJobList } from "../../../../common/hooks/api/job";
import { toastError } from "../../../../helpers/toast-helper";
import { getResponseData } from "../../../../helpers/response-helper";
import { TSelectOption } from "../../../../common/types/common";

export const useJobOptions = (): { options: TSelectOption[]; isLoading: boolean; } => {
    const { data: userList, isLoading } = useJobList({ pagination: { pageSize: 10000, pageIndex: 1 }, sorting: {}, filtering: { } }, {
        onError: () => {
            toastError("Can not fetch jobs list");
        },
    });
    const { data: users } = getResponseData(userList);
    const options = useMemo(() =>
        users?.length
            ? users
                .map((item) => ({ value: item.id, label: item.name || item.companyName }))
                .filter(item => item.label)
            : [], [users]);

    return {
        options,
        isLoading,
    };
};
